import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { isPendingAction, isRejectedAction, isFullfieldAction } from './slice.helper';
import Api from '../../services/tache.service';

export const listTacheReview = createAsyncThunk(
    "Tache/adm-list",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.getUserReview()
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const listTache = createAsyncThunk(
    "Tache/adm-listTache",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.getTasksList(data)
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)
export const listMyTaches = createAsyncThunk(
    "Tache/adm-listMyTaches",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.getMyTasksList(data)
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const createTache = createAsyncThunk(
    "Tache/adm-createTache",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.createTask(data)
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const updateTache = createAsyncThunk(
    "Tache/adm-updateTache",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.updateTask(data)
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const deleteTache = createAsyncThunk(
    "Tache/adm-deleteTache",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.deleteTask(data)
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

const initialState = {
    loading: false,
    error: '',
    sel_Tache: null
}

const TacheSlice = createSlice({
    name: "Tache",
    initialState: initialState,
    reducers: {
        clear: (state) => {
            Object.assign(state, initialState)
        },
        set_error: (state , action) => {
            state.error = action.payload
        },

    },
    extraReducers: builder => {
        builder
            .addMatcher(isFullfieldAction, (state, action) => {
                state[action.meta.requestId] = 'fulfilled'
                state.loading = false;
                state.error = '';
            })
            .addMatcher(isPendingAction, (state, action) => {
                state[action.meta.requestId] = 'pending'
                state.loading = true;
                state.error = '';
            })
            .addMatcher(isRejectedAction, (state, action) => {
                state[action.meta.requestId] = 'rejected'
                state.loading = false;
                state.error = action.payload;
            })



    }
})

const { reducer } = TacheSlice;
export const { clear , set_error } = TacheSlice.actions;
export default reducer;